import { CSSProperties, MouseEventHandler } from "react";

type Props = {
  size?: number;
  onClick?: MouseEventHandler<HTMLDivElement>;
  style?: CSSProperties;
};

export function Wordmark({ size = 18, onClick, style }: Props) {
  return (
    <div
      onClick={onClick}
      style={{
        fontFamily: "var(--sa-sans)",
        fontWeight: 600,
        fontSize: size,
        letterSpacing: "-0.01em",
        color: "var(--sa-fg)",
        cursor: onClick ? "pointer" : "default",
        display: "inline-flex",
        alignItems: "baseline",
        gap: 1,
        ...style,
      }}
    >
      <span>Submitter</span>
      <span style={{ color: "var(--sa-accent)", fontWeight: 500 }}>AI</span>
    </div>
  );
}
